import { render, staticRenderFns } from "./MapPos.vue?vue&type=template&id=24fa838a"
import script from "./MapPos.vue?vue&type=script&lang=js"
export * from "./MapPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports